var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner-wrapper"},[_c('fulfilling-square-spinner',{attrs:{"animation-duration":2500,"size":30,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }